export const LICENSE_TYPES = [
  'AM', 'A1', 'A2', 'A', 'B', 'BE', 'C', 'CE', 'D', 'DE',
  'VVF1_APS_ABP', 'VVF2_AS_AV', 'VVF3_Autobotte', 'VVF4_Autoscala',
] as const;

export type LicenseTypeCode = typeof LICENSE_TYPES[number];

export const LICENSE_LABEL: Record<LicenseTypeCode, string> = {
  AM: 'AM (ciclomotore)',
  A1: 'A1 (moto 125)',
  A2: 'A2 (moto 35kW)',
  A: 'A (moto senza limiti)',
  B: 'B (auto)',
  BE: 'BE (auto + rimorchio)',
  C: 'C (camion)',
  CE: 'CE (camion + rimorchio)',
  D: 'D (autobus)',
  DE: 'DE (autobus + rimorchio)',
  VVF1_APS_ABP: 'VVF I - APS/ABP',
  VVF2_AS_AV: 'VVF II - AS/AV',
  VVF3_Autobotte: 'VVF III - Autobotte',
  VVF4_Autoscala: 'VVF IV - Autoscala',
};

export function isVvfLicense(type: LicenseTypeCode): boolean {
  return type.startsWith('VVF');
}

// Livelli abilitazione patente VVF mostrati quando la competenza Autista e' selezionata
// (richiesta Bryan). NB: lista UI distinta dai LICENSE_TYPES VVF (codici APS/AS/Autobotte/...).
// Il backend non ha un enum equivalente: se in futuro venisse introdotto, allineare qui.
export const AUTISTA_VVF_LEVELS = ['VVF', 'VVF I°', 'VVF II°', 'VVF III°', 'VVF VI°'] as const;

export const VVF_GRADES = ['VF', 'CS', 'CR', 'VI', 'IS'] as const;
export type VvfGrade = typeof VVF_GRADES[number];
export const VVF_GRADE_LABEL: Record<VvfGrade, string> = {
  VF: 'Vigile del Fuoco (VF)',
  CS: 'Capo Squadra (CS)',
  CR: 'Capo Reparto (CR)',
  VI: 'Vigile Ispettore (VI)',
  IS: 'Ispettore (IS)',
};
